export default [
  {
    dataIndex:'rawName',
    fixed: 'left',
    // title: '名称',
    scopedSlots: {customRender: 'rawName'},
    slots: { title: 'customTitle' },
    sorter: (a, b) => a.rawName.localeCompare(b.rawName,'zh'),
    ellipsis: true,
    width: 160
  },
  {
    dataIndex:'rawCode',
    title: '代码',
    sorter: (a, b) => a.rawCode - b.rawCode,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80
  },
  {
    dataIndex:'price',
    scopedSlots: {customRender: 'price'},
    align:'center',
    title: '价格',
    sorter: (a, b) => a.price - b.price,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 100,
  },
  {
    dataIndex:'uasge',
    align:'center',
    title: '重量',
    scopedSlots: {customRender: 'uasge'},
    sorter: (a, b) => a.uasge - b.uasge,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80,
  },
  {
    dataIndex:'percentage',
    align:'center',
    title: '用量(%)',
    scopedSlots: {customRender: 'percentage'},
    sorter: (a, b) => a.percentage - b.percentage,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80,
  },
  {
    dataIndex:'minValue',
    scopedSlots: {customRender: 'minValue'},
    align:'center',
    title: '最小值',
    sorter: (a, b) => a.minValue - b.minValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80,
  },
  {
    dataIndex:'maxValue',
    scopedSlots: {customRender: 'maxValue'},
    align:'center',
    title: '最大值',
    sorter: (a, b) => a.maxValue - b.maxValue,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80,
  },
  {
    dataIndex:'cost',
    align:'center',
    title:'单位成本',
    scopedSlots: {customRender: 'cost'},
    sorter: (a, b) => a.cost - b.cost,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80
  },
  {
    dataIndex:'minShadowPrice',
    align:'center',
    title:'影子价格下限',
    scopedSlots: {customRender: 'minShadowPrice'},
    sorter: (a, b) => a.minShadowPrice - b.minShadowPrice,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 100
  },
  {
    dataIndex:'maxShadowPrice',
    align:'center',
    title:'影子价格上限',
    scopedSlots: {customRender: 'maxShadowPrice'},
    sorter: (a, b) => a.maxShadowPrice - b.maxShadowPrice,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 100
  },
  {
    dataIndex:'minApply',
    align:'center',
    title:'适用下限',
    scopedSlots: {customRender: 'minApply'},
    sorter: (a, b) => a.minApply - b.minApply,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80
  },
  {
    dataIndex:'maxApply',
    align:'center',
    title:'适用上限',
    scopedSlots: {customRender: 'maxApply'},
    sorter: (a, b) => a.maxApply - b.maxApply,
    sortDirections: ['descend', 'ascend'],
    ellipsis: true,
    width: 80
  },
]